var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "react", "prop-types", "../../Teasers/TeaserShow/TeaserShow", "../../Teasers/TeaserSeeAll/TeaserSeeAll", "../../Teasers/TeaserVideo/TeaserVideo", "../../Teasers/TeaserVOD/TeaserVOD", "../../Teasers/TeaserBrochure/TeaserBrochure", "../../Presse/TeaserLandscape/TeaserLandscape", "./SingleLineSlider.css", "../../UI/TitlesElement/TitlesElement", "../../Teasers/TeaserConcert/TeaserConcert"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("react"), require("prop-types"), require("../../Teasers/TeaserShow/TeaserShow"), require("../../Teasers/TeaserSeeAll/TeaserSeeAll"), require("../../Teasers/TeaserVideo/TeaserVideo"), require("../../Teasers/TeaserVOD/TeaserVOD"), require("../../Teasers/TeaserBrochure/TeaserBrochure"), require("../../Presse/TeaserLandscape/TeaserLandscape"), require("./SingleLineSlider.css"), require("../../UI/TitlesElement/TitlesElement"), require("../../Teasers/TeaserConcert/TeaserConcert"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.propTypes, global.TeaserShow, global.TeaserSeeAll, global.TeaserVideo, global.TeaserVOD, global.TeaserBrochure, global.TeaserLandscape, global.SingleLineSlider, global.TitlesElement, global.TeaserConcert);
    global.GenericTeaser = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _react, _propTypes, _TeaserShow, _TeaserSeeAll, _TeaserVideo, _TeaserVOD, _TeaserBrochure, _TeaserLandscape, _SingleLineSlider, _TitlesElement, _TeaserConcert) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _TeaserShow = _interopRequireDefault(_TeaserShow);
  _TeaserSeeAll = _interopRequireDefault(_TeaserSeeAll);
  _TeaserVideo = _interopRequireDefault(_TeaserVideo);
  _TeaserVOD = _interopRequireDefault(_TeaserVOD);
  _TeaserBrochure = _interopRequireDefault(_TeaserBrochure);
  _TeaserLandscape = _interopRequireDefault(_TeaserLandscape);
  _TitlesElement = _interopRequireDefault(_TitlesElement);
  _TeaserConcert = _interopRequireDefault(_TeaserConcert);

  var GenericTeaser = function GenericTeaser(_ref) {
    var activeIndex = _ref.activeIndex,
        index = _ref.index,
        kind = _ref.kind,
        onSlideFocus = _ref.onSlideFocus,
        onTeaserClick = _ref.onTeaserClick,
        placeholders = _ref.placeholders,
        teaser = _ref.teaser,
        theme = _ref.theme,
        themeName = _ref.themeName,
        touchDevice = _ref.touchDevice,
        visible = _ref.visible,
        visibleSlides = _ref.visibleSlides,
        withoutTitle = _ref.withoutTitle;
    var ComputedTeaser;

    switch (teaser.kind) {
      case 'SEEALL':
        ComputedTeaser = _TeaserSeeAll.default;
        break;

      case 'VIDEO':
        ComputedTeaser = _TeaserVideo.default;
        break;

      case 'VOD':
        ComputedTeaser = _TeaserVOD.default;
        break;

      case 'PROGRAM_PRESSE':
        ComputedTeaser = _TeaserLandscape.default;
        break;

      case 'PRESSE':
        ComputedTeaser = _TeaserLandscape.default;
        break;

      case 'BROCHURE':
        ComputedTeaser = _TeaserBrochure.default;
        break;

      default:
        ComputedTeaser = _TeaserShow.default;
        break;
    }

    if (themeName === 'concert' && ComputedTeaser === _TeaserShow.default) {
      ComputedTeaser = _TeaserConcert.default;
    }

    var titleFormat = theme && theme.teaser && theme.teaser.title ? theme.teaser.title.format : 'oneline';
    var titlesElement = teaser.title && !withoutTitle ? /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
      theme: theme,
      isPlaceholder: placeholders > 0,
      slideKind: kind ? kind.code : null,
      title: teaser.title,
      subtitle: teaser.subtitle,
      format: titleFormat
    }) : undefined;
    return /*#__PURE__*/_react.default.createElement(_SingleLineSlider.StyledSlide, {
      themeName: themeName,
      key: "".concat(teaser.id, "-").concat(index),
      _kind: kind,
      active: activeIndex === index,
      touchDevice: touchDevice,
      onClick: function onClick(event) {
        onTeaserClick(event, index);
      }
    }, /*#__PURE__*/_react.default.createElement(ComputedTeaser, (0, _extends2.default)({
      thumbnailEnabled: !touchDevice,
      titlesElement: titlesElement,
      visible: visible && visibleSlides[index] || touchDevice
    }, teaser, {
      onFocus: function onFocus() {
        return onSlideFocus({
          index: index
        });
      }
    })));
  };

  GenericTeaser.propTypes = {
    activeIndex: _propTypes.default.number,
    index: _propTypes.default.number,
    kind: _propTypes.default.string,
    onSlideFocus: _propTypes.default.func,
    onTeaserClick: _propTypes.default.func,
    placeholders: _propTypes.default.number,
    teaser: _propTypes.default.shape(),
    theme: _propTypes.default.shape(),
    themeName: _propTypes.default.string,
    touchDevice: _propTypes.default.bool,
    visible: _propTypes.default.bool,
    visibleSlides: _propTypes.default.arrayOf(_propTypes.default.bool),
    withoutTitle: _propTypes.default.bool
  };
  var _default = GenericTeaser;
  _exports.default = _default;
});